import { Link } from 'components/navigation/Link/Link';
import classnames from 'classnames';

const SeeAll = ({ link, className, onClick, labelText }) => {
  return (
    <Link
      to={link}
      type="link"
      ariaLabel={`${labelText ?? 'SEE ALL'}`}
      onClickCallback={onClick}
      className={classnames(
        'text-center Body2 m-text-12 m-margT6 link',
        className,
      )}
    >
      {labelText ? labelText : 'SEE ALL'}
    </Link>
  );
};

export default SeeAll;
